export class OAClient {
	id: string;
	secret: string;
    description: string;
    redirect_uri: string;
    disabled: boolean = false;
    trusted: boolean = false;
    landing_page_uri: string;
}